import { Form, Select, SelectProps, FormInstance } from 'antd';
import React from 'react';
import { hintChildren, hintIconText } from '@/presentation/components/hint-text/hintText';
import { compareModeText, compareStatusText } from '@/presentation/components/issue-list/components/tips';
import { FIELD_ALL } from '@/proto/field';
import styles from './index.module.scss';

enum CompareStatusEnum {
  ALL = 0,
  LEGACY = 2,
  ADD = 1,
  SOLVED = 3
}

const COMPARE_STATUS_OPTIONS: SelectProps['options'] = [
  { value: CompareStatusEnum.ALL, label: '所有' },
  { value: CompareStatusEnum.LEGACY, label: '遗留' },
  { value: CompareStatusEnum.ADD, label: '新增' },
  { value: CompareStatusEnum.SOLVED, label: '已解决' },
];

const TOP_DATA_DEFAULT = '3000';

const TOP_DATA_OPTIONS: SelectProps['options'] = [
  { value: FIELD_ALL, label: '全量数据' },
  { value: TOP_DATA_DEFAULT, label: hintChildren('Top数据', '按上报次数分别取A，B条件下的Top10000问题进行对比，推荐使用该模式。') },
];
interface IProps {
  form: FormInstance;
  compareStatusChange: (allValues: CompareStatusFormType) => void;
}

export interface CompareStatusFormType {
  compareStatus: number;
  topData: string;
}

export const compareStatusInitialValues = {
  compareStatus: CompareStatusEnum.ALL,
  topData: TOP_DATA_DEFAULT,
};

export const CompareForm = (props: IProps) => {
  const { form, compareStatusChange } = props;
  const onChange = (_values: CompareStatusFormType, allValues: CompareStatusFormType) => {
    compareStatusChange(allValues);
  };
  return <Form<CompareStatusFormType> initialValues={compareStatusInitialValues} preserve={false}  onValuesChange={onChange} form={form} className={styles.compareForm} layout={'vertical'}>
      <Form.Item className={'w-[278px] m-0'} name={'compareStatus'} label={hintIconText('对比状态', compareStatusText)}>
        <Select options={COMPARE_STATUS_OPTIONS}/>
      </Form.Item>
      <Form.Item className={'w-[278px] m-0'} name={'topData'} label={hintIconText('对比模式', compareModeText)}>
        <Select options={TOP_DATA_OPTIONS}/>
      </Form.Item>
    </Form>;
};
